import React from 'react';

import Typography from '@material-ui/core/Typography';
import { RootReducer } from 'store/reducers';
import { connect } from 'react-redux';
import Spinner from 'components/spinner';
import { AppLangType } from 'types/translation';

const UNSUPPORTED_ROUTE_TEXT = 'UNSUPPORTED_ROUTE_TEXT';

export interface IError404Props {
  lang: AppLangType;
}

function Error404({ lang }: IError404Props) {
  if (!lang) {
    return <Spinner />;
  }

  return (
    <Typography data-testid="404-info" align="center" variant="h2">
      {lang[UNSUPPORTED_ROUTE_TEXT]}
    </Typography>
  );
}

const mapState = (state: RootReducer) => {
  const {
    document: { lang },
  } = state;
  return {
    lang: lang.app,
  };
};

export default connect(mapState)(Error404);
